import { ScrollAreaAutosize } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { gameRoute } from 'shared/routing';
import { NavList } from 'shared/ui';
import { gameAsideModel } from '../../model';
import cls from './game-aside.module.scss';

export const GameAside = () => {
	const { t } = useTranslation();

	const [activeGame, setActiveGame, games] = useUnit([
		gameAsideModel.$activeGame,
		gameAsideModel.setActiveGame,
		gameAsideModel.$games,
	]);

	return (
		<div className={cls.gameAside}>
			<h2 className={cls.gameAsideTitle}>{t('cashier-layout.games')}</h2>
			<ScrollAreaAutosize className={cls.gameAsideScroll}>
				<div className={cls.gameAsideLinks}>
					{games.map((game) => (
						<NavList.Item
							key={game.id}
							data-test-id={`cashier-layout-game-${game.id}`}
							to={gameRoute}
							query={{ id: game.id }}
							activeParam={game.id === activeGame}
							className={cls.gameAsideLink}
							onClick={() => setActiveGame(game.id)}
						>
							{game.title}
						</NavList.Item>
					))}
				</div>
			</ScrollAreaAutosize>
		</div>
	);
};
